import React from 'react';
import './index.css';
import '../../showcase.css';
import classNames from "classnames";
import {ShowcaseInfo} from "../../type";
import Header from "../../../header";
import Footer from "../../../footer";
import Nav from "../../nav";
import HeroImage from '../../../hero-img';

interface CollectionTemplateProps {
  info: ShowcaseInfo;
  className?: string;
}

const CollectionTemplate: React.FC<CollectionTemplateProps> = props => {
  return (
    <div className={classNames("showcase collection", props.className)}>
      <Header />
      <Nav info={props.info}/>
      <article>
        <h1 className={"title"}>{props.info.title}</h1>
        <div className={"hero-image"}>
          {typeof props.info.heroImage === "string" ? <img alt={"Hero"} src={props.info.heroImage} /> : props.info.heroImage}
        </div>
        <div>
          {props.children}
        </div>
      </article>
      <Footer />
    </div>
  );
}

export default CollectionTemplate;
